/* MindStrips growth redesign: quick-add to cart + toast. No dependencies. */
(function(){
  function toast(msg){
    var t=document.getElementById('mnToast');
    if(!t){t=document.createElement('div');t.id='mnToast';t.className='mn-toast';t.setAttribute('role','status');t.setAttribute('aria-live','polite');document.body.appendChild(t);}
    t.innerHTML='<span>'+msg+'</span><a class="btn btn-grad" style="padding:10px 16px" href="/cart">View bag</a>';
    t.classList.add('on');clearTimeout(t._h);t._h=setTimeout(function(){t.classList.remove('on');},6000);
  }
  function setCount(n){document.querySelectorAll('#mnBagCount,.mn-drawer .mdbag .count').forEach(function(c){c.textContent=n;});document.querySelectorAll('.cartbtn').forEach(function(a){a.setAttribute('aria-label','Bag, '+n+' items');});}
  window.mnAdd=function(items){
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw new Error(j.description||j.message||'Could not add to bag');return j;});})
      .then(function(){return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});})
      .then(function(c){setCount(c.item_count);return c;});
  };
  document.addEventListener('click',function(e){
    var b=e.target.closest('.qadd[data-vid]');if(!b)return;e.preventDefault();
    var it={id:parseInt(b.getAttribute('data-vid'),10),quantity:parseInt(b.getAttribute('data-qty')||'1',10)};
    if(b.getAttribute('data-plan'))it.selling_plan=parseInt(b.getAttribute('data-plan'),10);
    var label=b.textContent;b.disabled=true;b.textContent='Adding…';
    window.mnAdd([it]).then(function(){
      if(b.getAttribute('data-reload')){window.location.reload();return;}
      b.textContent='Added';toast((b.getAttribute('data-name')||'Item')+' added to your bag');
      setTimeout(function(){b.textContent=label;b.disabled=false;},1800);
    }).catch(function(err){b.textContent=label;b.disabled=false;toast(err.message);});
  });
  /* smooth-scroll only on precise pointers; native scrolling on touch */
  window.mnUseLenis=function(){return !!window.Lenis && !matchMedia('(pointer: coarse)').matches && !matchMedia('(prefers-reduced-motion: reduce)').matches;};
})();
